import { render } from "./2FaVerificationForm.vue?vue&type=template&id=cfb1ea58"
import script from "./2FaVerificationForm.vue?vue&type=script&lang=js"
export * from "./2FaVerificationForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__